import React from 'react';
import { useRecurrenceManagementForm } from "../RecurrenceManagementFormProvider";

const OccurrencesMessage = (props) => {
    const {
        calculatedOccurrences,
        validCount,
        rescheduledCount,
        toBeRescheduledCount,
    } = useRecurrenceManagementForm();

    if (!calculatedOccurrences.length) {
        return <div>Your recurrence settings do not have any valid occurrences</div>
    }

    return <div>
        <p>
            {validCount} occurrences out of {calculatedOccurrences.length} are available!<br/>
            <a onClick={(e) => props.onToggle(!props.showAvailable)}>
                Click to {(props.showAvailable) ? 'hide' : 'show'} available occurrences
            </a>
        </p>

        {(toBeRescheduledCount > 0) && (
            <p>
                Reschedule <strong>{toBeRescheduledCount}</strong> unavailable occurrence(s):
            </p>
        )}

        {(!toBeRescheduledCount && !!rescheduledCount) && (
            <p style={{color: 'green'}}>
                All unavailable occurrences dealt with!
            </p>
        )}
    </div>
};

OccurrencesMessage.propTypes = {
};

OccurrencesMessage.defaultProps = {};

export default OccurrencesMessage;
